import {
  PasswordInput,
  TextInput,
  Button,
  Flex,
  Box,
  Anchor,
  Text,
} from '@mantine/core';
import { useForm } from '@mantine/form';
import { IconMail } from '@tabler/icons-react';
import { Link, useNavigate } from 'react-router';
import classes from './authForm.module.scss';
import { zodResolver } from 'mantine-form-zod-resolver';
import { VALIDATE_SCHEMA } from './types';
import { useSignIn } from '@entities/auth/api/hooks/mutations';
import { showNotification } from '@shared/utils';

export const AuthForm = () => {
  const navigate = useNavigate();
  const { mutate: mutateSignIn, isPending } = useSignIn();

  const form = useForm({
    mode: 'uncontrolled',
    initialValues: {
      email: '',
      password: '',
    },
    validate: zodResolver(VALIDATE_SCHEMA),
  });

  const handleSubmit = (values: typeof form.values) => {
    mutateSignIn(values, {
      onSuccess: () => {
        navigate('/');
      },
      onError: error => {
        const emailError = error?.response?.data.errors?.email;
        const errorPassword = error?.response?.data.errors?.password;

        if (emailError) {
          form.setFieldError('email', emailError);
        }

        if (errorPassword) {
          form.setFieldError('password', errorPassword);
        }

        showNotification({
          error,
          variant: 'error',
          message:
            error.response?.data.message || 'Ошибка при отправке запроса',
          color: 'red',
        });
      },
    });
  };

  return (
    <form onSubmit={form.onSubmit(handleSubmit)}>
      <Flex gap='1rem' direction='column'>
        <Box>
          <Flex>
            <Text
              component='label'
              htmlFor='password'
              className={classes.label}
            >
              Email
            </Text>
          </Flex>
          <TextInput
            {...form.getInputProps('email')}
            key={form.key('email')}
            placeholder='your@email.com'
            withAsterisk
            w='100%'
            leftSection={
              <Box px='0.3rem' pt='0.3rem'>
                <IconMail color='var(--mantine-color-primary-4)' size={20} />
              </Box>
            }
            error={form.errors.email}
            radius='0.75rem'
          />
        </Box>

        <Box className={classes.passwordField}>
          <Flex justify='space-between' align='flex-start'>
            <Text
              component='label'
              htmlFor='password'
              className={classes.label}
            >
              Пароль
            </Text>
          </Flex>

          <PasswordInput
            {...form.getInputProps('password')}
            key={form.key('password')}
            type='password'
            w='100%'
            id='password'
            radius='0.75rem'
            error={form.errors.password}
          />
          <Anchor
            component={Link}
            to='/recover-password'
            size='xs'
            className={classes.anchor}
          >
            Забыли пароль?
          </Anchor>
        </Box>
      </Flex>

      <Button
        type='submit'
        my='2rem'
        fullWidth
        className={classes.loginButton}
        variant='primary'
        loading={isPending}
      >
        Войти
      </Button>
    </form>
  );
};
